import type { RiskFlowAlert } from "./riskflow-feed";

export function formatExpandedImpliedPointsLabel(
  alert: RiskFlowAlert,
): string | null {
  const points = formatPointMagnitude(alert.pointRange);
  if (!points) return null;
  const instrument = formatInstrument(alert.instrument ?? alert.symbols?.[0]);
  if (!instrument) return `+/- ${points} pts`;
  return `+/- ${points} pts (${instrument})`;
}

function formatPointMagnitude(value: number | null | undefined): string | null {
  if (value == null) return null;
  const magnitude = Math.abs(Number(value));
  if (!Number.isFinite(magnitude) || magnitude === 0) return null;
  if (magnitude >= 10) return magnitude.toFixed(0);
  if (magnitude >= 1) return trimTrailingZero(magnitude.toFixed(1));
  return trimTrailingZero(magnitude.toFixed(2));
}

function formatInstrument(value: string | null | undefined): string | null {
  const trimmed = value?.trim();
  if (!trimmed) return null;
  const cleaned = trimmed.replace(/^[/$]/, "").toUpperCase();
  return cleaned ? `$${cleaned}` : null;
}

function trimTrailingZero(value: string): string {
  return value.replace(/\.0$/, "");
}
